!function(){
  // ==== Configuration ====
  const CONFIG = {
    TEST_ID: "SB-096DM",
    TEST_NAME: "Sticky Add to Cart: One-Time vs Subscription Options",
    BUCKET: "Variation 1",

    STYLES: {
      FONT: "font-weight: 900; font-size: 11px",
      SUCCESS: `background:rgb(${Math.floor(Math.random() * (254 - 50 + 1)) + 50}, 83, 65); color: #FFFFFF`,
      WARNING: "background:rgb(251, 200, 174); color: #F62817"
    },

    SELECTORS: {
      BODY: "body",
      SUBSCRIPTION_CONTENTS: ".subscription-contents",
      SUBSCRIPTION_CHECKED: ".subscription-contents input:checked",
      FREQUENCY_SELECTOR: "select.frequency-selector",
      SKIO_HOST: "skio-plan-picker",
      SKIO_FIELDSET: "fieldset.skio-plan-picker",
      SKIO_SHADOW_SELECTED: ".group-container.group-container--selected input",
      SKIO_SHADOW_GROUPS: ".group-container",
      SKIO_SHADOW_FREQUENCY: ".selling-plan-dropdown",
    },

    CHECK_URL: "https://cdn.shopify.com/s/files/1/0866/7664/files/green-check.svg",
    CROSS_URL: "https://cdn.shopify.com/s/files/1/0866/7664/files/cross.svg",

    ARROW: `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
      <path d="M11.91 -4.33072e-07L12.97 1.061L7.193 6.84C7.10043 6.93315 6.99036 7.00708 6.86911 7.05753C6.74786 7.10798 6.61783 7.13395 6.4865 7.13395C6.35517 7.13395 6.22514 7.10798 6.10389 7.05753C5.98264 7.00708 5.87257 6.93315 5.78 6.84L2.65457e-07 1.061L1.06 0.00099902L6.485 5.425L11.91 -4.33072e-07Z" fill="#111314"/>
    </svg>`,

    CLOSE: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clip-path="url(#clip0_219_105)">
        <path d="M5.98966 5.98959L18.0105 18.0104M18.0105 5.98959L5.98966 18.0104" stroke="#111314" stroke-linecap="round"/>
      </g>
      <defs>
        <clipPath id="clip0_219_105">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>`,

    VP: [
      'Free Shipping',
      'Cancel or pause anytime'
    ],

    TIMEOUT: 30000,
    INTERVAL: 25,
    OBSERVER: true
  };

  // ==== Styled Console Logging ====
  const STYLE = CONFIG.STYLES;
  const log = {
    success: (msg) => console.log(`%c ${msg} `, `${STYLE.SUCCESS};${STYLE.FONT}`),
    warning: (msg) => console.warn(`%c ${msg} `, `${STYLE.WARNING};${STYLE.FONT}`),

    start() {
      this.success(`==== ${CONFIG.TEST_ID} START ====`);
      this.success(`ID: ${CONFIG.TEST_ID} \n NAME: ${CONFIG.TEST_NAME} \n BUCKET: ${CONFIG.BUCKET} `);
    },
    end() {
      this.success(`==== ${CONFIG.TEST_ID} END ====`);
    },
    fail(error) {
      this.warning(`%c ERROR => ${error.message}`, `${STYLE.WARNING};${STYLE.FONT}`);
      this.warning(`%c ${CONFIG.TEST_ID} x x x x x Failed`, `${STYLE.WARNING};${STYLE.FONT}`);
    }
  };

  console.log(`%c [${CONFIG.TEST_ID}] Bucketed into: ${CONFIG.BUCKET}`, `${STYLE.SUCCESS};${STYLE.FONT}`);

  // ==== Utility Functions ====
  const utils = {
    q: (s, e = document) => e.querySelector(s),
    qs: (s, e = document) => e.querySelectorAll(s),
    eh: (el, pos, html) => el.insertAdjacentHTML(pos, html),
    ie: (el, pos, node) => el.insertAdjacentElement(pos, node),

    wait(selector, cb, {
      multiple = false,
      isVariable = false,
      minCount = 1,
      timeout = CONFIG.TIMEOUT,
      interval = CONFIG.INTERVAL,
      el = document
    } = {}) {
      const start = Date.now();
      (function check() {
        const result = isVariable
          ? window[selector]
          : (multiple ? utils.qs(selector, el) : utils.q(selector, el));

        const isReady = isVariable
          ? typeof result !== 'undefined'
          : (multiple ? result.length >= minCount : !!result);

        if (isReady) cb(result);
        else if (Date.now() - start < timeout) setTimeout(check, interval);
      })();
    },

    debounce(fn, delay) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn.apply(this, args), delay);
      };
    },

    isMobile() {
      return window.matchMedia("(max-width: 767px)").matches;
    },

    injectStyle(id, css) {
      if (document.getElementById(id)) return;
      const style = document.createElement("style");
      style.id = id;
      style.setAttribute("type","text/css");
      style.textContent = css;
      document.head.appendChild(style);
    },

    isInViewport(el) {
      if (!el) return false;
      const rect = el.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const windowWidth = window.innerWidth || document.documentElement.clientWidth;
      return (
        rect.top < windowHeight &&
        rect.bottom > 0 &&
        rect.left < windowWidth &&
        rect.right > 0
      );
    },

    syncStickyFrequencySelects(stickyDetails, mainSelect) {
      if (!stickyDetails || !mainSelect) return;
      const mainOptionsHtml = mainSelect.innerHTML;
      stickyDetails.querySelectorAll('.r-sf-select select').forEach((stickySel) => {
        stickySel.removeAttribute('id');
        if (stickySel.innerHTML !== mainOptionsHtml) {
          stickySel.innerHTML = mainOptionsHtml;
        }
        stickySel.value = mainSelect.value;
      });
    },

    matchVariantForSticky(variants, sizeValue, flavorValue) {
      const list = variants || [];
      if (!list.length) return null;
      const sz = String(sizeValue ?? '').trim();
      const fl = String(flavorValue ?? '').trim();
      if (sz && fl) {
        const m = list.find(
          (v) =>
            String(v.option1 || '').trim() === sz &&
            String(v.option2 || '').trim() === fl
        );
        return m || list[0];
      }
      if (fl && !sz) {
        let m = list.find((v) => String(v.option2 || '').trim() === fl);
        if (m) return m;
        m = list.find((v) => {
          const o1 = String(v.option1 || '').trim();
          const o2 = String(v.option2 || '').trim();
          return o1 === fl && !o2;
        });
        if (m) return m;
        m = list.find((v) => String(v.option1 || '').trim() === fl);
        return m || list[0];
      }
      if (sz && !fl) {
        const m =
          list.find((v) => String(v.option1 || '').trim() === sz) ||
          list.find((v) => String(v.option2 || '').trim() === sz);
        return m || list[0];
      }
      return list[0];
    },

    updateStickyImage(variant) {
      const wrapper = utils.q('.sb-sticky-atc__image');
      const img = wrapper && wrapper.querySelector('img');
      if (!img || !variant) return;
      const src = variant.featured_image && variant.featured_image.src;
      if (!src) return;
      const base = src.replace(/[?&]width=\d+/, '').replace(/\?$/, '');
      const sized = base + (base.includes('?') ? '&' : '?') + 'width=136';
      if (img.src === sized || img.getAttribute('src') === sized) return;
      img.src = sized;
      img.srcset = sized + ' 136w';
    },

    getSubscriptionContext() {
      const resolveSkioPlanRoot = () => {
        const skioHost = utils.q(CONFIG.SELECTORS.SKIO_HOST);
        const shadow = skioHost && skioHost.shadowRoot;
        if (shadow) {
          const groups = shadow.querySelectorAll(CONFIG.SELECTORS.SKIO_SHADOW_GROUPS);
          const type = utils.q(CONFIG.SELECTORS.SKIO_SHADOW_SELECTED, shadow);
          if (groups.length >= 2 && type) return shadow;
        }
        const fieldset = utils.q(CONFIG.SELECTORS.SKIO_FIELDSET);
        if (fieldset) {
          const groups = fieldset.querySelectorAll(CONFIG.SELECTORS.SKIO_SHADOW_GROUPS);
          const type = utils.q(CONFIG.SELECTORS.SKIO_SHADOW_SELECTED, fieldset);
          if (groups.length >= 2 && type) return fieldset;
        }
        return null;
      };
      const planRoot = resolveSkioPlanRoot();
      if (planRoot) {
        return {
          mode: 'skio',
          shadow: planRoot instanceof ShadowRoot ? planRoot : null,
          getMainFrequencySelect() {
            return utils.q(CONFIG.SELECTORS.SKIO_SHADOW_FREQUENCY, planRoot);
          },
          getOneTime() {
            const inp = utils.q(CONFIG.SELECTORS.SKIO_SHADOW_SELECTED, planRoot);
            return !!(inp && inp.value === 'One time purchase');
          },
          syncStickyChoiceToMain(isOnetime, isSubscription) {
            const grps = Array.from(planRoot.querySelectorAll(CONFIG.SELECTORS.SKIO_SHADOW_GROUPS));
            const targetGroup = grps.find((g) => {
              const inp = g.querySelector('input');
              if (!inp) return false;
              if (isOnetime) return inp.value === 'One time purchase';
              if (isSubscription) return inp.value !== 'One time purchase';
              return false;
            });
            if (!targetGroup) return;
            const input = targetGroup.querySelector('input');
            if (input) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
            targetGroup.click();
          }
        };
      }
      const subRoot = utils.q(CONFIG.SELECTORS.SUBSCRIPTION_CONTENTS);
      const typeInput = subRoot && utils.q(CONFIG.SELECTORS.SUBSCRIPTION_CHECKED);
      if (subRoot && typeInput) {
        return {
          mode: 'light',
          shadow: null,
          subRoot,
          getMainFrequencySelect() {
            return utils.q(CONFIG.SELECTORS.FREQUENCY_SELECTOR, subRoot)
              || utils.q(CONFIG.SELECTORS.FREQUENCY_SELECTOR);
          },
          getOneTime() {
            const inp = utils.q(CONFIG.SELECTORS.SUBSCRIPTION_CHECKED);
            return !!(inp && inp.value === 'one-time');
          },
          syncStickyChoiceToMain(isOnetime, isSubscription) {
            const value = isOnetime ? 'one-time' : (isSubscription ? 'subscription' : '');
            if (!value) return;
            const input = subRoot.querySelector(`input[value="${value}"]`);
            if (input && !input.checked) input.click();
          }
        };
      }
      return null;
    }
  };

  // ==== Main Test Logic ====
  const test = {
    init() {
      this.injectCSS();
      this.bindStickySync();
      this.bindStickyButtonToMainATC();
      this.bindResize();
      this.main();
      if (CONFIG.OBSERVER) this.observeMutations();
    },

    bindStickyButtonToMainATC() {
      if (this._stickyButtonBound) return;
      this._stickyButtonBound = true;
      const syncLoadingFromMain = () => {
        const mainBtn = utils.q('.product-form__submit');
        const stickyBtn = utils.q('.sb-sticky-atc__button');
        if (!mainBtn || !stickyBtn) return;
        const mainHasLoading = mainBtn.classList.contains('loading');
        if (mainHasLoading) stickyBtn.classList.add('loading');
        else stickyBtn.classList.remove('loading');
      };
      const ensureStickyHasSpinner = () => {
        const stickyBtn = utils.q('.sb-sticky-atc__button');
        if (!stickyBtn || stickyBtn.querySelector('.r-sticky-spinner')) return;
        const span = document.createElement('span');
        span.className = 'r-sticky-spinner';
        span.setAttribute('aria-hidden', 'true');
        stickyBtn.insertBefore(span, stickyBtn.firstChild);
      };
      const observeMainLoading = () => {
        const mainBtn = utils.q('.product-form__submit');
        if (!mainBtn || mainBtn._rLoadingObserved) return;
        mainBtn._rLoadingObserved = true;
        const mo = new MutationObserver(syncLoadingFromMain);
        mo.observe(mainBtn, { attributes: true, attributeFilter: ['class'] });
      };
      utils.wait('.product-form__submit', () => {
        observeMainLoading();
      });
      utils.wait('.sb-sticky-atc__button', () => {
        ensureStickyHasSpinner();
        syncLoadingFromMain();
      });

      document.addEventListener('click', (e) => {
        if (!e.target.closest('.sb-sticky-atc__button')) return;
        const ctx = utils.getSubscriptionContext();
        e.preventDefault();
        e.stopPropagation();
        if (ctx) {
          const isOneTime = ctx.getOneTime();
          ctx.syncStickyChoiceToMain(isOneTime, !isOneTime);
        }
        ensureStickyHasSpinner();
        const mainBtn = utils.q('.product-form__submit');
        if (mainBtn) {
          mainBtn.click();
          [0, 50, 150, 400].forEach((ms) => setTimeout(syncLoadingFromMain, ms));
        }
      }, true);
    },

    bindResize() {
      if (this._resizeBound) return;
      this._resizeBound = true;
      this._wasMobile = utils.isMobile();
      const onResize = utils.debounce(() => {
        const nowMobile = utils.isMobile();
        if (nowMobile === this._wasMobile) return;
        this._wasMobile = nowMobile;
        const sticky = document.querySelector('sb-sticky-add-to-cart');
        const el = sticky?.querySelector('.r-sticky-details');
        if (el) el.remove();
        this._lastStickySize = undefined;
        this.main();
      }, 150);
      window.addEventListener('resize', onResize);
    },

    injectCSS() {
      const css = `
        .sb-sticky-atc__button {
          position: relative;
          height: 44px;
          padding: 8px 32px 10px;
        }
        .sb-sticky-atc__button .r-sticky-spinner {
          display: none;
          position: absolute;
          left: 50%;
          top: 50%;
          width: 18px;
          height: 18px;
          margin-left: -9px;
          margin-top: -9px;
          border: 2px solid currentColor;
          border-top-color: transparent;
          border-radius: 50%;
          animation: r-sticky-spin 0.6s linear infinite;
          z-index: 2;
        }
        .sb-sticky-atc__button.loading .r-sticky-spinner {
          display: block !important;
        }
        .sb-sticky-atc__button.loading::before {
          content: '';
          position: absolute;
          inset: 0;
          background: inherit;
          border-radius: inherit;
          z-index: 1;
          pointer-events: none;
        }
        @keyframes r-sticky-spin {
          to { transform: rotate(360deg); }
        }

        .r-sticky-prices {
          display: flex;
          align-items: center;
          gap: 6px;
          margin-top: 4px;
        }
        .r-sp-original {
          color: #1B73B3;
          font-size: 16px;
          font-weight: 700;
          line-height: 100%;
        }
        .r-sp-current {
          color: #676767;
          font-size: 14px;
          line-height: 100%;
          text-decoration-line: line-through;
        }

        .r-sticky-details select.frequency-selector,
        .r-sticky-details select.selling-plan-dropdown {
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          display: flex;
          align-items: center;
          gap: 5px;
          height: 45px;
          max-width: 134px;
          margin-top: 5px;
          padding: 8px 30px 8px 10px;
          background-color: var(--sb-bg-color, #fff);
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='7' viewBox='0 0 12 7' fill='none'%3E%3Cpath d='M12 0.427268C12 0.33238 11.9625 0.235274 11.8897 0.162453C11.744 0.0168114 11.5057 0.0168114 11.3601 0.162453L6.37514 5.14737L1.46304 0.235274C1.3174 0.089632 1.07907 0.089632 0.933432 0.235274C0.78779 0.380916 0.78779 0.619239 0.933432 0.764881L6.11033 5.94399C6.25598 6.08963 6.4943 6.08963 6.63994 5.94399L11.8897 0.694267C11.9647 0.619239 12 0.524362 12 0.427268Z' fill='%23111314' fill-opacity='0.6'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 10px top 50%;
          background-size: 12px;
          border: 1px solid rgba(103, 103, 103, 0.32);
          border-radius: 2px;
          font-size: 14px;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: 400;
          font-style: normal;
          line-height: 140%;
          letter-spacing: 0;
          color: #000;
          padding: 0 0 0 16px;
          min-height: 32px;
          height: 32px;
          width: auto;
          min-width: 111px;
          margin-top: unset;
        }

        .r-sticky-details {
          margin: 0 auto 0 80px;
          width: 100%;
          max-width: 600px;
        }
        .r-sticky-frequency {
          font-size: 16px;
          font-weight: 500;
          line-height: 100%;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        .r-sf-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .r-sf-item {
          display: flex;
        }
        .r-sf-item.r-sf-subscription {
          flex-direction: column;
          gap: 8px;
        }
        .r-sf-save {
          display: inline-flex;
          padding: 3px 5px 6px 5px;
          width: fit-content;
          border-radius: 3px;
          background: #1B73B3;
          color: #FFF;
          line-height: 120%;
        }
        .r-sf-radio {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 16px;
          height: 16px;
          border-radius: 88px;
          border: 1px solid #111314;
        }
        .r-sf-radio-inner {
          width: 10px;
          height: 10px;
          border-radius: 10px;
          background: #111314;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .r-sf-select {
          display: none;
        }
        .r-sf-item.r-sf-active .r-sf-radio-inner,
        .r-sf-item.r-sf-active .r-sf-select {
          display: block !important;
        }
        .r-sf-header {
          display: flex;
          align-items: center;
          gap: 10px;
          cursor: pointer;
        }
        .r-sf-label {
          line-height: 75%;
          margin-bottom: -2px;
        }
        .r-sf-onetime .r-sf-label {
          margin-bottom: 2px;
        }

        .r-sticky-value-prop {
          display: flex;
          align-items: center;
          gap: 40px;
          justify-content: space-between;
          width: 100%;
        }
        .r-sticky-value-prop-container {
          display: none;
        }
        .r-sf-item.r-sf-active .r-sticky-value-prop-container {
          display: flex !important;
        }
        @media only screen and (min-width: 768px) {
          .r-sticky-value-prop--desktop {
            display: flex !important;
            align-items: center;
            gap: 40px;
          }
          .r-sf-item.r-sf-subscription > .r-sticky-value-prop-container:not(.r-sticky-value-prop--desktop) {
            display: none !important;
          }
          .r-sticky-value-prop--desktop .r-svp-icon--check {
            display: flex !important;
          }
          .r-sticky-value-prop--desktop .r-svp-icon--cross {
            display: none !important;
          }
          .r-sticky-details--onetime .r-sticky-value-prop--desktop .r-svp-icon--check {
            display: none !important;
          }
          .r-sticky-details--onetime .r-sticky-value-prop--desktop .r-svp-icon--cross {
            display: flex !important;
          }
        }
        @media only screen and (max-width: 767px) {
          .r-sticky-value-prop--desktop {
            display: none !important;
          }
        }
        .r-svp-item {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
        }
        .r-svp-icon {
          display: flex;
          width: 16px;
          height: 16px;
          flex-shrink: 0;
        }
        .r-svp-icon img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
          transform: translateZ(0);
        }
        .r-svp-text {
          color: rgba(17, 19, 20, 0.56);
          font-size: 14px;
          font-weight: 700;
          line-height: 130%;
        }
        @media only screen and (min-width: 768px) {
          .sb-sticky-atc__content {
            margin: 10px auto;
          }
          .sb-sticky-atc__details {
            min-width: fit-content;
            gap:6px;
          }
          .sb-sticky-atc__image {
            width: 78px;
            height: 78px;
          }
          h3.sb-sticky-atc__title {
            color: #111314;
            font-size: 18px;
            font-weight: 500;
            line-height: 120%;
          }
          .r-sf-item.r-sf-subscription {
            height: 32px;
            justify-content: center;
          }
        }
        @media only screen and (max-width: 1280px) and (min-width: 768px) {
          .r-sticky-details {
            margin-left: 10px;
          }
          .r-sticky-value-prop {
            gap: 8px;
          }
          .r-svp-text {
            font-size: 12px;
          }
          .r-svp-icon {
            width: 14px;
            height: 14px;
          }
        }
        @media only screen and (max-width: 767px) {
          .sb-sticky-atc__reviews {
            display: none !important;
          }
          .sb-sticky-atc__button {
            padding: 8px 16px 10px;
          }
          sb-sticky-add-to-cart {
            padding-top: 0 !important;
          }
          .sb-sticky-atc__content .r-sticky-details,
          .r-sticky-details.r-sticky-details--mobile {
            width: 100%;
            max-width: none;
          }
          .sb-sticky-atc__content {
            display: flex;
            flex-wrap: wrap;
          }
          .sb-sticky-atc__content .r-sticky-details,
          .sb-sticky-atc__content .r-sticky-details.r-sticky-details--mobile {
            flex-basis: 100%;
          }
          .sb-sticky-atc__title {
            font-size: 12px;
            font-family: 'neue-haas-unica', sans-serif;
            font-weight: 500;
          }

          .r-sticky-prices {
            margin-top: 4px;
          }

          .r-sticky-details {
            margin: 0 auto;
            border-top: 1px solid rgba(17, 19, 20, 0.10);
          }
          .r-sf-free-shipping {
            color: #111314;
            font-size: 12px;
            line-height: 120%;
            opacity: 0.6;
          }
          .r-sticky-selected {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #F8F9FB;
            padding: 8px 16px 12px 16px;
            margin-bottom: 10px;
            border-top: 1px solid rgba(17, 19, 20, 0.10);
            border-bottom: 1px solid rgba(17, 19, 20, 0.10);
          }
          .r-sf-edit {
            color: #111314;
            font-size: 16px;
            line-height: 100%;
          }
          .r-sticky-selected-btn {
            display: flex;
            align-items: center;
            gap: 2px;
            padding-bottom: 2px;
            border-bottom: 1px solid #111314;
          }
          .r-sf-arrow {
            width: 24px;
            height: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: transform 0.3s ease;
          }
          .r-sticky-details:not(.r-sticky-details--frequency-collapsed) .r-sf-arrow {
            transform: rotate(180deg);
          }
          .r-sticky-frequency {
            padding: 40px 16px 24px 16px;
            position: relative;
            overflow: hidden;
            max-height: 600px;
            opacity: 1;
            transition: max-height 0.35s ease, padding 0.35s ease, opacity 0.25s ease;
            flex-direction: column-reverse;
            gap: 12px;
          }
          .r-sticky-details--frequency-collapsed .r-sticky-frequency {
            max-height: 0;
            padding-top: 0;
            padding-bottom: 0;
            opacity: 0;
          }
          .r-sticky-details--onetime .r-sf-label.r-sf-subs {
            display: none !important;
          }
          .r-sticky-details:not(.r-sticky-details--onetime) .r-sticky-selected-header .r-sf-label.r-sf-onetime-label {
            display: none !important;
          }
          .r-sf-subscribe-label, .r-sf-onetime-label {
            font-size: 14px;
          }

          .r-sticky-close {
            width: 24px;
            height: 24px;
            position: absolute;
            top: 8.5px;
            right: 16px;
            cursor: pointer;
          }
          .r-sticky-badge {
            display: flex;
            padding: 2px 10px 6px 10px;
            justify-content: center;
            align-items: center;
            gap: 10px;
            width: fit-content;
            position: absolute;
            left: 28px;
            top: 17px;
            border-radius: 8px;
            border: 4px solid #FFF;
            background: #173446;
            color: #FFF;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 100%;
          }
          .r-sf-item {
            padding: 16px 12px;
            border-radius: 6px;
            border: 1px solid rgba(17, 19, 20, 0.32);
          }
          .r-sf-active {
            border: 1.5px solid #111314;
          }
          .r-sticky-value-prop {
            flex-direction: column;
            align-items: flex-start;
            gap: 6px;
          }
          .r-sticky-value-prop-container {
            display: none;
            justify-content: space-between;
            align-items: flex-end;
            padding-top: 10px;
            border-top: 1px solid rgba(103, 103, 103, 0.32);
          }
          .r-sf-item.r-sf-subscription {
            gap: 18px;
          }
           .r-svp-text {
            font-weight: 400;
          }
          .r-svp-item:first-child .r-svp-text {
            font-weight: 700;
          }
          .r-sf-header {
            width: 100%;
          }
          .r-sf-onetime .r-sp-original {
            margin-left: auto;
            color: #111314;
          }
          .r-sf-subscription .r-sticky-prices {
            margin: 0 0 0 auto;
            display: flex;
            flex-direction: column-reverse;
            align-items: flex-end;
            gap: 6px;
          }
        }
        @supports (-webkit-touch-callout: none) {
          @media screen and (max-width: 768px) {
            /* iOS-specific styles */
          }
        }

        .sb-sticky-atc__image {
          transition: opacity 0.2s ease;
        }
        .sb-sticky-atc__image.r-img-loading {
          opacity: 0.4;
        }
      `;
      utils.injectStyle(CONFIG.TEST_ID, css);
    },

    bindStickySync() {
      if (this._stickySyncBound) return;
      this._stickySyncBound = true;
      document.addEventListener('click', (e) => {
        const onetime = e.target.closest('.r-sf-onetime');
        const subscription = e.target.closest('.r-sf-subscription');
        if (!onetime && !subscription) return;
        const ctx = utils.getSubscriptionContext();
        if (!ctx) return;
        ctx.syncStickyChoiceToMain(!!onetime, !!subscription);
      });
      document.addEventListener('change', (e) => {
        const stickySelect = e.target.closest('.r-sticky-details .r-sf-select select');
        if (!stickySelect) return;
        const ctx = utils.getSubscriptionContext();
        if (!ctx) return;
        const mainSel = ctx.getMainFrequencySelect();
        if (!mainSel || mainSel.value === stickySelect.value) return;
        mainSel.value = stickySelect.value;
        mainSel.dispatchEvent(new Event('change', { bubbles: true }));
      });
      document.addEventListener('click', (e) => {
        if (e.target.closest('.r-sticky-selected-btn') || e.target.closest('.r-sticky-close')) {
          const details = e.target.closest('.r-sticky-details');
          if (details) details.classList.toggle('r-sticky-details--frequency-collapsed');
        }
      });
    },

    main() {
      const pathname = window.location.pathname;
      if (this._productDataUrl && this._productDataUrl !== pathname) {
        this._productData = null;
        this._productDataUrl = null;
      }
      const ctx = utils.getSubscriptionContext();
      if (!ctx) return;
      const skioDropdown = ctx.getMainFrequencySelect();
      if (skioDropdown && !skioDropdown._rStickySyncAttached) {
        skioDropdown._rStickySyncAttached = true;
        skioDropdown.addEventListener('change', () => {
          const details = utils.q('.sb-sticky-atc__details');
          if (!details) return;
          const content = details.closest('.sb-sticky-atc__content');
          const stickyDetailsContainer = utils.isMobile() ? (content && content.parentNode) : details.parentNode;
          const stickyDetails = stickyDetailsContainer && utils.q('.r-sticky-details', stickyDetailsContainer);
          if (stickyDetails) utils.syncStickyFrequencySelects(stickyDetails, skioDropdown);
        });
      }
      const oneTime = ctx.getOneTime();
      if (this._stickyFetchPending) return;
      const details = utils.q('.sb-sticky-atc__details');
      const sizeEl = utils.q('variant-selects input:checked');
      const flavorEl = utils.q('.sb-flavor-selected__text');
      if (!details) return;
      const sizeValue = sizeEl ? String(sizeEl.value).trim() : '';
      const flavorValue = flavorEl ? flavorEl.textContent.trim() : '';
      if (!sizeValue && !flavorValue) return;
      const existingPrices = utils.q('.r-sticky-prices', details);
      const selectionUnchanged =
        existingPrices &&
        this._lastStickySize === sizeValue &&
        this._lastStickyFlavor === flavorValue &&
        this._lastStickyOneTime === oneTime;
      if (selectionUnchanged) {
        const contentEarly = details.closest('.sb-sticky-atc__content');
        const stickyDetailsContainerEarly = utils.isMobile() ? (contentEarly && contentEarly.parentNode) : details.parentNode;
        const stickyDetailsEarly = stickyDetailsContainerEarly && utils.q('.r-sticky-details', stickyDetailsContainerEarly);
        const mainFreqEarly = ctx.getMainFrequencySelect();
        if (stickyDetailsEarly && mainFreqEarly) utils.syncStickyFrequencySelects(stickyDetailsEarly, mainFreqEarly);
        return;
      }

      const updatePricesFromData = (data) => {
        const variants = data.variants || [];
        const variant = utils.matchVariantForSticky(variants, sizeValue, flavorValue);

        const plan0 = variant && variant.selling_plan_allocations && variant.selling_plan_allocations[0];

        // FIX: keep the two prices explicitly named.
        //  - One-time (OTP) price  = variant.price
        //  - Subscribe & Save price = selling_plan_allocations[0].price
        // Previously `price` was always the plan price, so the one-time view
        // showed the S&S price, and the subscription view rendered the OTP
        // price in the bold "active" style and the S&S price struck through.
        const otpPrice = variant ? variant.price : data.price;
        const subPrice = plan0 ? plan0.price : otpPrice;

        const fmt = (cents) => (cents != null && cents !== '') ? '$' + (Number(cents) / 100).toFixed(2) : '';
        const otpFormatted = fmt(otpPrice);
        const subFormatted = fmt(subPrice);

        const hasDiscount = otpPrice != null && subPrice != null && Number(subPrice) < Number(otpPrice);
        const saveAmount = hasDiscount ? Math.round((otpPrice - subPrice) / 100) : 0;
        const savePercent = hasDiscount ? Math.round(((otpPrice - subPrice) / otpPrice) * 100) : 0;

        const dynamicVP = [
          savePercent > 0 ? `Save ${savePercent}% on every order` : `Save $${saveAmount} on every order`,
          ...CONFIG.VP
        ];

        // Note on classes: .r-sp-original = bold blue (active price),
        // .r-sp-current = grey strikethrough (reference price).
        const otpPriceHtml = `<span class="r-sp-original">${otpFormatted}</span>`;
        const subPriceInner = `<span class="r-sp-original">${subFormatted}</span>${hasDiscount ? `
              <span class="r-sp-current">${otpFormatted}</span>` : ''}`;

        const prev = utils.q('.r-sticky-prices', details);
        if (prev) prev.remove();
        utils.eh(details, 'beforeend', `<div class="r-sticky-prices">
            ${oneTime ? otpPriceHtml : subPriceInner}
          </div>`);
        this._lastStickySize = sizeValue;
        this._lastStickyFlavor = flavorValue;
        this._lastStickyOneTime = oneTime;

        utils.updateStickyImage(variant);

        const content = details.closest('.sb-sticky-atc__content');
        const stickyDetailsContainer = utils.isMobile() ? (content && content.parentNode) : details.parentNode;
        const sticky = details.closest('sb-sticky-add-to-cart');
        const existingAll = sticky ? Array.from(utils.qs('.r-sticky-details', sticky)) : [];

        if (existingAll.length > 1) {
          existingAll.slice(1).forEach((el) => el.remove());
        }

        let stickyDetails = existingAll.length > 0 ? existingAll[0] : null;
        if (stickyDetails) {
          if (stickyDetailsContainer && stickyDetails.parentNode !== stickyDetailsContainer) {
            if (utils.isMobile() && content) {
              content.parentNode.insertBefore(stickyDetails, content);
            } else {
              stickyDetailsContainer.appendChild(stickyDetails);
            }
          }
          stickyDetails.classList.toggle('r-sticky-details--mobile', !!utils.isMobile());
          stickyDetails.classList.toggle('r-sticky-details--onetime', !!oneTime);
          const onetimeEl = utils.q('.r-sf-onetime', stickyDetails);
          const subEl = utils.q('.r-sf-subscription', stickyDetails);
          if (onetimeEl) onetimeEl.classList.toggle('r-sf-active', oneTime);
          if (subEl) subEl.classList.toggle('r-sf-active', !oneTime);
          const skioSelect = ctx.getMainFrequencySelect();
          utils.syncStickyFrequencySelects(stickyDetails, skioSelect);

          // Keep the "Save" copy in sync on every pass.
          const saveLineText = dynamicVP[0];
          utils.qs('.r-svp-item:first-child .r-svp-text', stickyDetails).forEach((el) => {
            el.textContent = saveLineText;
          });
          utils.qs('.r-sf-save', stickyDetails).forEach((el) => {
            el.textContent = `Save $${saveAmount}`;
          });

          // FIX: also refresh the per-option prices (mobile drawer) so they
          // don't go stale when the variant changes.
          const otpRowPrice = onetimeEl && utils.q('.r-sf-header > .r-sp-original', onetimeEl);
          if (otpRowPrice) otpRowPrice.textContent = otpFormatted;
          const subRowPrices = subEl && utils.q('.r-sticky-prices', subEl);
          if (subRowPrices) subRowPrices.innerHTML = subPriceInner;
        }

        const select = ctx.getMainFrequencySelect();
        if (details && existingAll.length === 0 && select) {
          const mobileClass = utils.isMobile() ? ' r-sticky-details--mobile r-sticky-details--frequency-collapsed' : '';
          const onetimeClass = oneTime ? ' r-sticky-details--onetime' : '';
          const stickyHtml = `<div class="r-sticky-details${mobileClass}${onetimeClass}">
            <div class="r-sticky-frequency">
              <div class="r-sf-item r-sf-onetime${oneTime ? ' r-sf-active' : ''}">
                <div class="r-sf-header">
                  <div class="r-sf-radio">
                    <div class="r-sf-radio-inner"></div>
                  </div>
                  <div class="r-sf-label">One-Time Purchase</div>
                  ${utils.isMobile() ? otpPriceHtml : ''}
                </div>
              </div>
              <div class="r-sf-item r-sf-subscription${!oneTime ? ' r-sf-active' : ''}">
                <div class="r-sf-container">
                  <div class="r-sf-header">
                    <div class="r-sf-radio">
                      <div class="r-sf-radio-inner"></div>
                    </div>
                    <div class="r-sf-label">Subscribe and <span class="r-sf-save">Save $${saveAmount}</span></div>
                    ${utils.isMobile() ? `<div class="r-sticky-prices">
                      ${subPriceInner}
                    </div>` : ''}
                  </div>
                  ${utils.isMobile() ? `` : `<div class="r-sf-select">
                    ${select.outerHTML}
                  </div>`}
                </div>
                <div class="r-sticky-value-prop-container">
                  <div class="r-sticky-value-prop">
                    ${dynamicVP.map(vp => `<div class="r-svp-item">
                      <div class="r-svp-icon"><img src="${CONFIG.CHECK_URL}" alt="" width="32" height="32" /></div>
                      <div class="r-svp-text">${vp}</div>
                    </div>`).join('')}
                  </div>
                  ${utils.isMobile() ? `<div class="r-sf-select">
                    ${select.outerHTML}
                  </div>` : ''}
                </div>
              </div>
              <div class="r-sticky-value-prop-container r-sticky-value-prop--desktop">
                <div class="r-sticky-value-prop">
                  ${dynamicVP.map((vp) => `<div class="r-svp-item">
                    <div class="r-svp-icon r-svp-icon--check"><img src="${CONFIG.CHECK_URL}" alt="" width="32" height="32" /></div>
                    <div class="r-svp-icon r-svp-icon--cross"><img src="${CONFIG.CROSS_URL}" alt="" width="32" height="32" /></div>
                    <div class="r-svp-text">${vp}</div>
                  </div>`).join('')}
                </div>
              </div>
              ${utils.isMobile() ? `<div class="r-sticky-close">${CONFIG.CLOSE}</div>` : ''}
              ${utils.isMobile() ? `<div class="r-sticky-badge">Free Shipping</div>` : ''}
            </div>
            ${utils.isMobile() ? `<div class="r-sticky-selected">
              <div class="r-sticky-selected-header">
                <div class="r-sf-label r-sf-subs"><span class="r-sf-subscribe-label">Subscribe and</span> <span class="r-sf-save">Save $${saveAmount}</span> <span class="r-sf-free-shipping">+ Free Shipping</span></div>
                <div class="r-sf-label r-sf-onetime-label">One-Time Purchase</div>
              </div>
              <div class="r-sticky-selected-btn">
                <span class="r-sf-edit">Edit</span>
                <span class="r-sf-arrow">${CONFIG.ARROW}</span>
              </div>
            </div>` : ''}
          </div>`;
          if (utils.isMobile() && content) {
            utils.eh(content, 'beforebegin', stickyHtml);
          } else {
            utils.eh(details, 'afterend', stickyHtml);
          }
          const inserted = sticky && utils.q('.r-sticky-details', sticky);
          utils.syncStickyFrequencySelects(inserted, select);
        }
      };

      if (this._productData) {
        updatePricesFromData(this._productData);
        return;
      }

      this._stickyFetchPending = true;
      const url = pathname + '.js' + (window.location.search || '');
      fetch(url)
        .then((res) => {
          if (!res.ok) throw new Error('Fetch failed: ' + res.status);
          return res.json();
        })
        .then((data) => {
          this._productData = data;
          this._productDataUrl = pathname;
          updatePricesFromData(data);
          return data;
        })
        .catch((err) => console.warn('Fetch failed:', err))
        .finally(() => { this._stickyFetchPending = false; });
    },

    observeMutations() {
      const observer = new MutationObserver(utils.debounce(() => {
        this.main();
      }, 30));

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true
      });

      this.observer = observer;
    },

    destroy() {
      if (this.observer) this.observer.disconnect();
      const styleEl = document.getElementById(CONFIG.TEST_ID);
      if (styleEl) styleEl.remove();
    }
  };

  // ==== Bootstrapping the Test ====
  utils.wait(CONFIG.SELECTORS.BODY, (body) => {
    try {
      log.start();
      body.classList.add(CONFIG.TEST_ID);
      test.init();
      log.end();
    } catch (err) {
      log.fail(err);
    }
  });
}();